<template>
	<div>
		<div class="enroll-title">云南省综合运输区块链生态系统赋能管理平台</div>
		<div class="enroll-title" style="padding: 20px 0;">相关协议</div>

		<div class="center">
			<div>鉴于，几方同意共同投资经营 配送超市 ，为明确各方的权利义务，几方本着公平、平等、互利的原则订立合伙协议如下：</div>
			<div>第一条 经营宗旨：通过合法的手段，创造劳动成果，分享经济利益。第二条 合伙经营项目名称： 湘阴县龙腾海产配送超市 ，主要经营地址： 湘阴县东茅路精密现代城43栋门面 .经营项目： 海产品配送、海产品甲供 .第三条 合伙期限。 年 月 日起，第四条 出资金额、 方式；三合伙人平均每人出资 196215.00元，共计人民币 588645.00元作为租赁房屋、添置设备设施、门面装修及前期经营费用。合伙期间各合伙人的出资为共有财产，不得随意请求分割或收回。第五条 盈余分配与债务承担。</div>
			<div>
				合伙各方共同经营、共同劳动，共担风险，共负盈亏。
			</div>
			<div>
				1、盈余分配：以出资额各 1/3 为依据，按平均分配。
				2、债务承担：经营过程中的债务先以合伙财产偿还，合伙财产不足清偿时，合伙人共同承担。 任何一方对外偿还后，另外几方应当按投资比例在10日内向对方清偿自己应负担的部分。
			</div>
			<div>鉴于，几方同意共同投资经营 配送超市 ，为明确各方的权利义务，几方本着公平、平等、互利的原则订立合伙协议如下：</div>
			<div>第一条 经营宗旨：通过合法的手段，创造劳动成果，分享经济利益。第二条 合伙经营项目名称： 湘阴县龙腾海产配送超市 ，主要经营地址： 湘阴县东茅路精密现代城43栋门面 .经营项目： 海产品配送、海产品甲供 .第三条 合伙期限。 年 月 日起，第四条 出资金额、 方式；三合伙人平均每人出资 196215.00元，共计人民币 588645.00元作为租赁房屋、添置设备设施、门面装修及前期经营费用。合伙期间各合伙人的出资为共有财产，不得随意请求分割或收回。第五条 盈余分配与债务承担。</div>
			<div>
				合伙各方共同经营、共同劳动，共担风险，共负盈亏。
			</div>
			<div>
				1、盈余分配：以出资额各 1/3 为依据，按平均分配。
				2、债务承担：经营过程中的债务先以合伙财产偿还，合伙财产不足清偿时，合伙人共同承担。 任何一方对外偿还后，另外几方应当按投资比例在10日内向对方清偿自己应负担的部分。
			</div>
			<div>鉴于，几方同意共同投资经营 配送超市 ，为明确各方的权利义务，几方本着公平、平等、互利的原则订立合伙协议如下：</div>
			<div>第一条 经营宗旨：通过合法的手段，创造劳动成果，分享经济利益。第二条 合伙经营项目名称： 湘阴县龙腾海产配送超市 ，主要经营地址： 湘阴县东茅路精密现代城43栋门面 .经营项目： 海产品配送、海产品甲供 .第三条 合伙期限。 年 月 日起，第四条 出资金额、 方式；三合伙人平均每人出资 196215.00元，共计人民币 588645.00元作为租赁房屋、添置设备设施、门面装修及前期经营费用。合伙期间各合伙人的出资为共有财产，不得随意请求分割或收回。第五条 盈余分配与债务承担。</div>
			<div>
				合伙各方共同经营、共同劳动，共担风险，共负盈亏。
			</div>
			<div>
				1、盈余分配：以出资额各 1/3 为依据，按平均分配。
				2、债务承担：经营过程中的债务先以合伙财产偿还，合伙财产不足清偿时，合伙人共同承担。 任何一方对外偿还后，另外几方应当按投资比例在10日内向对方清偿自己应负担的部分。
			</div>
			<div>鉴于，几方同意共同投资经营 配送超市 ，为明确各方的权利义务，几方本着公平、平等、互利的原则订立合伙协议如下：</div>
			<div>第一条 经营宗旨：通过合法的手段，创造劳动成果，分享经济利益。第二条 合伙经营项目名称： 湘阴县龙腾海产配送超市 ，主要经营地址： 湘阴县东茅路精密现代城43栋门面 .经营项目： 海产品配送、海产品甲供 .第三条 合伙期限。 年 月 日起，第四条 出资金额、 方式；三合伙人平均每人出资 196215.00元，共计人民币 588645.00元作为租赁房屋、添置设备设施、门面装修及前期经营费用。合伙期间各合伙人的出资为共有财产，不得随意请求分割或收回。第五条 盈余分配与债务承担。</div>
			<div>
				合伙各方共同经营、共同劳动，共担风险，共负盈亏。
			</div>
			<div>
				1、盈余分配：以出资额各 1/3 为依据，按平均分配。
				2、债务承担：经营过程中的债务先以合伙财产偿还，合伙财产不足清偿时，合伙人共同承担。 任何一方对外偿还后，另外几方应当按投资比例在10日内向对方清偿自己应负担的部分。
			</div>
			<div>鉴于，几方同意共同投资经营 配送超市 ，为明确各方的权利义务，几方本着公平、平等、互利的原则订立合伙协议如下：</div>
			<div>第一条 经营宗旨：通过合法的手段，创造劳动成果，分享经济利益。第二条 合伙经营项目名称： 湘阴县龙腾海产配送超市 ，主要经营地址： 湘阴县东茅路精密现代城43栋门面 .经营项目： 海产品配送、海产品甲供 .第三条 合伙期限。 年 月 日起，第四条 出资金额、 方式；三合伙人平均每人出资 196215.00元，共计人民币 588645.00元作为租赁房屋、添置设备设施、门面装修及前期经营费用。合伙期间各合伙人的出资为共有财产，不得随意请求分割或收回。第五条 盈余分配与债务承担。</div>
			<div>
				合伙各方共同经营、共同劳动，共担风险，共负盈亏。
			</div>
			<div>
				1、盈余分配：以出资额各 1/3 为依据，按平均分配。
				2、债务承担：经营过程中的债务先以合伙财产偿还，合伙财产不足清偿时，合伙人共同承担。 任何一方对外偿还后，另外几方应当按投资比例在10日内向对方清偿自己应负担的部分。
			</div>
			<div>
				1、盈余分配：以出资额各 1/3 为依据，按平均分配。
				2、债务承担：经营过程中的债务先以合伙财产偿还，合伙财产不足清偿时，合伙人共同承担。 任何一方对外偿还后，另外几方应当按投资比例在10日内向对方清偿自己应负担的部分。
			</div>
			<div>鉴于，几方同意共同投资经营 配送超市 ，为明确各方的权利义务，几方本着公平、平等、互利的原则订立合伙协议如下：</div>
			<div>第一条 经营宗旨：通过合法的手段，创造劳动成果，分享经济利益。第二条 合伙经营项目名称： 湘阴县龙腾海产配送超市 ，主要经营地址： 湘阴县东茅路精密现代城43栋门面 .经营项目： 海产品配送、海产品甲供 .第三条 合伙期限。 年 月 日起，第四条 出资金额、 方式；三合伙人平均每人出资 196215.00元，共计人民币 588645.00元作为租赁房屋、添置设备设施、门面装修及前期经营费用。合伙期间各合伙人的出资为共有财产，不得随意请求分割或收回。第五条 盈余分配与债务承担。</div>
			<div>
				合伙各方共同经营、共同劳动，共担风险，共负盈亏。
			</div>
			<div>
				1、盈余分配：以出资额各 1/3 为依据，按平均分配。
				2、债务承担：经营过程中的债务先以合伙财产偿还，合伙财产不足清偿时，合伙人共同承担。 任何一方对外偿还后，另外几方应当按投资比例在10日内向对方清偿自己应负担的部分。
			</div>
		</div>

		<div class="getBack">
			<el-button type="primary" @click="enrollPage('enroll')">返回注册</el-button>
		</div>
	</div>
</template>

<script>
	export default {

		methods: {
			enrollPage(name) {
				this.$router.push({
					name: name
				})
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.enroll-title {
		text-align: center;
		font-size: 28px;
		font-weight: bold;
		color: #0078d2;
		-webkit-text-stroke: 1px #ffffff;
		letter-spacing: 5px;
		padding: 60px 0 0 0;
	}
	.center{
		padding: 10px 0 150px 0;
		height: calc(100vh - 156px );
		overflow: auto;
		div{
			margin: 0 5%;
			width: 90%;
			font-size: 16px;
			color: #333333;
			text-indent:40px;
			line-height: 36px;
			word-break:break-all;
			word-wrap:break-word;   
		}
	}
	.getBack {
		position: fixed;
		width: 100%;
		height: 100px;
		padding: 30px 0 0 0;
		left: 0;
		bottom: 0;
		text-align: center;
		background-color: #FFFFFF;
		z-index: 99;
		border-top: 1px solid rgba(0, 0, 0, 0.1);
	}
</style>
